<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
body {
  background: linear-gradient(360deg, #e8f4fa 0%, #fafafa 100%);
  // font-family: MEDIUM, REGULAR, SEMIBOLD;
  // font-family: Regular;
  // font-family: regular2;
  // font-family: regularTtf;
  min-height: 100vh;
  margin: 0 !important;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

li {
  list-style: none;
}

@media screen and (max-width: 768px) {
  // info页地址选择
  .infoCountryClass {
    width: 77.6vw;
  }
}
</style>
